import { api } from "../api";
import { logoApp } from "../iconos";
import type { Sesion } from "../../lib/tipos";

export function renderLogin(contenedor: HTMLElement, alEntrar: () => void): void {
  // Si la sesion se cayo a mitad de uso, api.ts dejo este flag antes de recargar.
  const vencida = sessionStorage.getItem("sesionCerrada") === "1";
  sessionStorage.removeItem("sesionCerrada");

  contenedor.innerHTML = `
    <div class="mx-auto mt-20 max-w-sm">
      <div class="tarjeta">
        <div class="mb-1 flex items-center gap-2 text-2xl font-bold">
          ${logoApp("h-10 w-10")} Míster Memoria
        </div>
        <p class="mb-5 text-sm text-apagado">Entrá para ver qué hay que hacer.</p>
        ${
          vencida
            ? `<p class="mb-4 rounded-lg border border-borde bg-realce px-3 py-2 text-sm text-apagado">La sesión venció. Entrá de nuevo.</p>`
            : ""
        }
        <form id="f" class="space-y-3">
          <label><span class="etiqueta">Usuario</span>
            <input id="usuario" class="campo" autocomplete="username" /></label>
          <label><span class="etiqueta">Clave</span>
            <input id="clave" type="password" class="campo" autocomplete="current-password" /></label>
          <p id="err" class="text-sm text-alerta"></p>
          <button class="btn-primario w-full">Entrar</button>
        </form>
      </div>
    </div>`;

  const form = contenedor.querySelector("#f") as HTMLFormElement;
  const err = contenedor.querySelector("#err") as HTMLElement;

  form.addEventListener("submit", async (ev) => {
    ev.preventDefault();
    err.textContent = "";
    const usuario = (contenedor.querySelector("#usuario") as HTMLInputElement).value.trim();
    const clave = (contenedor.querySelector("#clave") as HTMLInputElement).value;
    try {
      await api.post<Sesion>("/api/login", { usuario, clave });
      alEntrar();
    } catch (e) {
      err.textContent = e instanceof Error ? e.message : "No se pudo entrar";
    }
  });
}
